module.exports = __webpack_public_path__ + "img/hybrid-least-privilege-architecture.e26131e4.png";